import { useEffect, type ReactElement } from "react";
import { useLocation } from "react-router-dom";

export default function AdminPreferencesPage(): ReactElement {
  const location = useLocation();

  useEffect(() => {
    if (location.hash !== "#appearance") return;
    document.getElementById("appearance")?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [location.hash]);

  return (
    <div className="space-y-8">
      <header>
        <h1 className="text-2xl font-semibold text-gray-900">Preferences</h1>
        <p className="mt-1 text-sm text-gray-600">How Zephix looks on this device.</p>
      </header>

      <section
        id="appearance"
        className="scroll-mt-6 rounded-xl border border-gray-200 bg-white px-4 py-5 shadow-sm sm:px-6"
        data-testid="prefs-appearance-section"
      >
        <h2 className="text-xs font-semibold uppercase tracking-wide text-gray-400">Appearance</h2>
        <p className="mt-2 text-sm text-gray-600" data-testid="prefs-theme-pinned-note">
          Zephix uses the Light theme. Dark mode is not available yet.
        </p>
      </section>
    </div>
  );
}
